export const SET_EXPLORE_FILTER = 'SET_EXPLORE_FILTER';
export const SET_EXPLORE_SORT = 'SET_EXPLORE_SORT';
export const SET_EXPLORE_PAGE = 'SET_EXPLORE_PAGE';

export const GET_EXPLORE_JINGLES_REQUEST = 'GET_EXPLORE_JINGLES_REQUEST';
export const GET_EXPLORE_JINGLES_SUCCESS = 'GET_EXPLORE_JINGLES_SUCCESS';
export const GET_EXPLORE_JINGLES_FAILURE = 'GET_EXPLORE_JINGLES_FAILURE';

export const GET_EXPLORE_FULL_JINGLES_DATA_PER_PAGE_REQUEST = 'GET_EXPLORE_FULL_JINGLES_DATA_PER_PAGE_REQUEST';
export const GET_EXPLORE_FULL_JINGLES_DATA_PER_PAGE_SUCCESS = 'GET_EXPLORE_FULL_JINGLES_DATA_PER_PAGE_SUCCESS';
export const GET_EXPLORE_FULL_JINGLES_DATA_PER_PAGE_FAILURE = 'GET_EXPLORE_FULL_JINGLES_DATA_PER_PAGE_FAILURE';

export const CLEAR_EXPLORE_JINGLES_ACTION = 'CLEAR_EXPLORE_JINGLES_ACTION';
